module.exports = __webpack_public_path__ + "fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNa.woff";